module.exports = __webpack_public_path__ + "static/media/ขาล.afbc4bd0.jpg";